export default {
  name: 'it-infrastructure',
  translationKey: 'it-infrastructure-module',
  routePrefix: 'support-channels',
  routeNamePrefix: 'admin.it-infrastructure',
  directRoutesAvailable: false,
}
